import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useListUserGroups() {
  return useQuery({
    queryKey: ["user-groups"],
    queryFn: () => api.listUserGroups(),
  });
}
